import React from 'react';
import { DropdownContext } from './DropdownContext';
import PopoverWrapper from '../popover/PopoverWrapper';
const DropdownMenu = ({ children, className }) => {
    return (React.createElement(DropdownContext.Consumer, null, (value) => (React.createElement(PopoverWrapper, { role: 'menu', isOpen: value.isOpen, toggle: value.toggle, target: value.id, trigger: 'legacy', placement: value.direction, className: 'ac-dropdown-menu ' + (className ? className : ''), children: children }))));
};
export { DropdownMenu };
//# sourceMappingURL=DropdownMenu.js.map